import React, { Component } from "react";
import * as R from "ramda";

const ConnectComponent2 = (View, Presenter) => {
  return class ConnectComponentIntern extends Component {
    static displayName = `ConnectComponent(${View.name}, ${Presenter.name})`;

    constructor(props) {
      super(props);
      this._observableProps = R.omit("children", props);
      this._presenter = new Presenter(this._observableProps);
      this.state = this._presenter.initialState();
    }

    componentDidMount() {
      this._presenter._changeListener = (payload, cb) =>
        this.setState(payload, () => cb(this.state));
    }

    componentWillReceiveProps(nextProps) {
      if (!(this._presenter && this._presenter._props)) {
        return;
      }

      this._presenter._props = R.omit("children", nextProps);

      if (this._presenter.onChangeProps) {
        this._presenter.onChangeProps();
      }
    }

    componentWillUnmount() {
      if (this._presenter) {
        this._presenter.onEnd();
        this._presenter._changeListener = null;
      }
    }

    render() {
      return (
        <View
          presenter={this._presenter}
          viewModel={this.state}
          {...this.props}
        />
      );
    }
  };
};

export default ConnectComponent2;



// WEBPACK FOOTER //
// ./src/util/connect-component-2.js